import { ActionType } from "../interfaces/api/actionType";

export const GetInterviewStepTypes: ActionType = {
  FAILURE: "GET_INTERVIEW_STEP_TYPES_FAILURE",
  REQUEST: "GET_INTERVIEW_STEP_TYPES_REQUEST",
  SUCCESS: "GET_INTERVIEW_STEP_TYPES_SUCCESS",
};
